import { Component, OnDestroy, OnInit } from '@angular/core';
import { ApplicationViewsService } from '../../ApplicationViews/Services/application-views.services';
import { MaintenanceService } from '../../services/maintenance.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ApplicationViewsResource } from 'src/app/client-api.service';
import { tap } from 'rxjs/operators';
import { AddAccountsDialogService } from '../../ApplicationViews/Services/add-accounts-dialog.service';
import { Subscription } from 'rxjs';
import { PanelSize } from 'src/app/shared/tcc-ui/simple-panel/models';

@Component({
  selector: 'app-view-accounts',
  templateUrl: './view-accounts.component.html',
  styleUrls: ['./view-accounts.component.scss' ]
})
export class ViewAccountsComponent implements OnInit, OnDestroy {

  allApplicationViews: ApplicationViewsResource[] | undefined;
  applicationViews$ = this.appViewsServices.applicationViews$;

  currentView = '';
  filteredApplicationViews: ApplicationViewsResource[] | undefined;

  panalSize: PanelSize = 'full';
  state: 'initializing' | 'loading' | 'ready' | 'saving';  
  subs: Subscription[];

  constructor(private addAccountsDialogService: AddAccountsDialogService,
              private appViewsServices: ApplicationViewsService,
              private maintenanceService: MaintenanceService,
              private activatedRoute: ActivatedRoute,
              private router: Router) {
    this.state = 'initializing';  
    this.subs = [];

  }

  ngOnInit(): void {
    //this.appViewsServices.setApplicationViews();
    
    this.subs.push(this.applicationViews$.pipe(
      tap((v) => {        
        this.allApplicationViews = v;        
        this.filterViewAccounts(this.currentView);
        this.clearAll();        
      })
    ).subscribe());

    this.state = 'initializing';  
    this.subs.push(this.activatedRoute.params.subscribe(routeParam => {
      this.currentView =  routeParam['view'];      
      if(routeParam['view'] !== '') {
        
        this.filterViewAccounts(this.currentView);        
        this.clearAll();        
        this.state = 'ready';        
      }
      else {
        alert('Invalid view parameter for view accounts!');
        this.state = 'ready';        
      }
    }));
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }

  clearAll() {
    this.filteredApplicationViews?.forEach(a => {
      a.isChecked = false;
    })
  }

  close() {
    this.maintenanceService.setMaintenanceComponenetPanelSize('large');
    this.router.navigate(['.'], { relativeTo: this.activatedRoute.parent });
  }

  filterViewAccounts(viewName: string) {
    this.filteredApplicationViews = this.allApplicationViews?.filter(v => v.view === viewName);
  }

  onSelectedAccountSelected(accountCode: string, parentAccountCode: string) {
    const account = this.filteredApplicationViews?.find(a => a.accountCode === accountCode && a.parentAccountCode === parentAccountCode);
    if (account) {
      if (account.isChecked) {        
        this.removeChild(accountCode);
      }
      else {        
        this.addParent(account.accountCode);
      }
    }
  }

  addParent(accountCode: string) {
    const account = this.filteredApplicationViews?.find(a => a.accountCode === accountCode);
    if (account) {
      account.isChecked = false;
      this.addParent(account.parentAccountCode);
    }
  }

  removeChild(accountCode: string) {
    const account = this.filteredApplicationViews?.filter(a => a.parentAccountCode === accountCode);

    account?.forEach(a => {
      if (a) {
        a.isChecked = true; // we don't want to save this because it's parent is being removed
        this.removeChild(a.accountCode);
      }
    });
  }

  remove() {
    if(confirm('Are you sure you want to remove these Accounts from theis View?')) {
      this.state = 'saving';
      let ids: number[] = [];

      for (let account of this.filteredApplicationViews!) {
        if (account.isChecked) {
            ids.push(account.id);
        }
      }

      this.appViewsServices.deleteApplicationViews(ids).subscribe(() => {
        setTimeout(() => {
          this.appViewsServices.setApplicationViews();
          this.appViewsServices.setViewInfos();
          this.state = 'ready';  
        }, ids.length * 3);
        
      })      
    }
  }

  showAddAccountDialog() {
    const data = {viewName: this.currentView, currentViews: this.filteredApplicationViews}
    this.addAccountsDialogService.open('Ledger View Assignments', '', data);
    
    this.addAccountsDialogService.confirm$.subscribe(result => {
      this.appViewsServices.setApplicationViews();            
      if (result !== null) {
        console.log('Dialog confirmed with:', result);
      }
    });
  }
}
